import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { VehiclesDetailPage } from './vehicles-detail.page';

const routes: Routes = [
  {
    path: '',
    component: VehiclesDetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VehiclesDetailPageRoutingModule {}
